module.exports = __webpack_public_path__ + "static/media/_south-ossetia.edae3baa.png";